import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import NFFilter from '../components/FilterContainer';
import FilterForm from '../components/FilterForm';
import CheckboxControl from '../components/CheckboxControl';
import { SCHEDULING, schedulingEnumTransKey } from '../enums';

import { Container } from '../styles';

const label = Object.values(SCHEDULING);

const Scheduling = ({ isOpen, onClick, onApply, scheduled }) => {
  const [selectedItem, setSelectedItem] = useState(scheduled);

  useEffect(() => {
    if(scheduled?.length < 1) {
      setSelectedItem([]);
    }
  }, [scheduled]);

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Number(item) !== Number(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, e.target.value]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply([]);
  };

  return (
    <NFFilter label="Agendamento" isOpen={isOpen} onClick={onClick}>
      <FilterForm
        label="Filtrar por agendamento"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <Container>
          {label.map((filter, idx) => (
            <CheckboxControl
              key={Number(idx)}
              value={filter}
              onChange={handleChange}
              defaultChecked={selectedItem.some(
                item => parseInt(item) === filter,
              )}
              label={schedulingEnumTransKey[filter]}
            />
          ))}
        </Container>
      </FilterForm>
    </NFFilter>
  );
};

const mapStateToProps = state => ({
  scheduled: state.tracking.filters.scheduled,
});

export default connect(mapStateToProps)(Scheduling);
